import React from 'react';
export function DownloadIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.286 16.724a.999.999 0 001.448-.033c.2-.21 2.474-2.469 3.971-3.958a1 1 0 10-1.41-1.418c-.98.974-1.725 1.714-2.3 2.288L13 4a1 1 0 00-1-1 1 1 0 00-1 1v9.6l-2.292-2.294a1 1 0 00-1.416 1.412l3.994 4.006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11.03a1 1 0 00-1 1l-.009 6a1 1 0 01-1 1l-12-.018a1 1 0 01-1-1l.009-6a1 1 0 10-2 0l-.009 6a3 3 0 003 3l12 .018a3 3 0 003-3l.009-6a1 1 0 00-1-1z"
  }));
}